export default "__VITE_ASSET__TV6mBDNU__"